import React from 'react';

type ReportMeasurableElementProps = {
  setRef: any;
  currentTotalHeight?: number;
  pageHeight?: number;
  updatePage?: () => void;
  key?: number | string;
  shouldStartNewPage?: boolean;
};

type ReportMeasurableElementState = {
  update: boolean;
};

export default class ReportMeasurableElement extends React.Component<
  ReportMeasurableElementProps,
  ReportMeasurableElementState
> {
  private childrenWithProps: any;
  constructor(props) {
    super(props);
    this.state = {
      update: false,
    };
    this.childrenWithProps = [];
  }

  updateWrapper = () => {
    this.setState({ update: true });
    if (!!this.props.updatePage) {
      this.props.updatePage();
    }
  };

  render() {
    const {
      key,
      setRef,
      currentTotalHeight = 0,
      pageHeight,
      shouldStartNewPage,
    } = this.props;
    if (!pageHeight) {
      return <div data-testid="emptyDiv" />;
    }

    const heightTillPageBreak = pageHeight - currentTotalHeight;

    this.childrenWithProps = React.Children.map(this.props.children, child => {
      // Host nodes such as div cannot accept updateWrapper. Passing it
      // through makes React warn and emit it as a DOM attribute.
      if (!React.isValidElement(child) || typeof child.type === 'string') {
        return child;
      }
      return React.cloneElement(
        child as React.ReactElement<{ updateWrapper?: () => void }>,
        {
          updateWrapper: () => {
            this.updateWrapper();
          },
        }
      );
    });

    return (
      <div
        key={key || ''}
        data-testid={'measurableWrapper'}
        ref={setRef}
        style={
          shouldStartNewPage
            ? //50px is there as an edge case where heightTillPageBreak exactly matches 0
              {
                marginTop: `${heightTillPageBreak || 50}px`,
              }
            : {}
        }
      >
        {
          // @ts-ignore
          this.childrenWithProps
        }
      </div>
    );
  }
}
